import React, {useEffect} from 'react'
import {Col, Row} from "antd";
import FilterTable from "./fragments/filterTable";
import FilterSelect from "./fragments/filterSelect";
import {FILTER_BY_NO_BARCODE} from "./constants";
import ExelExportBtn from "./fragments/ExelExportBtn";
import {useFirestoreConnect, isLoaded} from 'react-redux-firebase'
import {useSelector} from "react-redux";

export default function ProductFilterView() {
    const [filter, setFilter] = React.useState(FILTER_BY_NO_BARCODE);
    const [data, setData] = React.useState([]);

    useFirestoreConnect(() => [
        {collection: 'items', where: [[filter, '==', null]], limit: 10, storeAs: `${filter}_item1`},
        {collection: 'items', where: [[filter, '==', " "]], limit: 10, storeAs: `${filter}_item2`}
    ])

    const store_items1 = useSelector((state) => state.firestore.ordered[`${filter}_item1`]);
    const store_items2 = useSelector((state) => state.firestore.ordered[`${filter}_item2`]);


    useEffect(() => {

        if (store_items1 && store_items2)
            setData(store_items1.concat(store_items2))

    }, [store_items1, store_items2])


    const handleFilterChange = (filter) => {
        setFilter(filter)
        // console.log(filter)
    }


    return (
        <Col>
            <Row>
                <Col>
                    <FilterSelect onSelect={handleFilterChange}/>
                </Col>
                <Col className='rig'>
                    <ExelExportBtn data={data}/>
                </Col>
            </Row>
            <Row>

                <FilterTable
                    rows={store_items1}
                    isLoading={()=> !isLoaded(store_items1, store_items2)}
                />
            </Row>
        </Col>
    )
}
